let ControllerName = 'Auth';
const AuthController = Object.freeze({
    Register: `${ControllerName}/register`,
    ResetPass: `${ControllerName}/reset-password`,
    ForgetPass: `${ControllerName}/forgot-password`,
    RegisterOtp: `${ControllerName}/resend-otp`,
    Activate: `${ControllerName}/activate`,
    ResetResend: `${ControllerName}/resend-reset-otp`,
    PassActivate: `${ControllerName}/validate-reset-otp`,
    refreshToken: `${ControllerName}/refresh-token`,
    externalSignUp: `${ControllerName}/external-register`,
    externalSignIn: `${ControllerName}/external-login`,
});

export default AuthController;
